// Google Analytics 유틸리티 함수
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

// 페이지 조회 추적
export const trackPageView = (pageName) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
    });
  }
};

// 버튼 클릭 추적
export const trackButtonClick = (buttonName, section = null) => {
  if (analytics) {
    logEvent(analytics, 'select_content', {
      content_type: 'button',
      content_id: buttonName,
      custom_parameter_1: section,
    });
  }
};

// 연락처 클릭 추적
export const trackContactClick = (contactType) => {
  if (analytics) {
    logEvent(analytics, 'contact_interaction', {
      contact_type: contactType,
    });
  }
};

// 스크롤 깊이 추적
export const trackScrollDepth = (percentage) => {
  if (analytics) {
    logEvent(analytics, 'scroll', {
      percent_scrolled: percentage,
    });
  }
};

// 커스텀 이벤트 추적
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};
